import React from 'react';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
import { serviceAreas } from '../data/serviceAreas';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const points = ['about.point1', 'about.point2', 'about.point3'];
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="w-full bg-white py-20 sm:py-24" data-id="element-3" data-mp="33qglm6u8yk69">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-16 lg:px-8" data-id="element-4" data-mp="38pt7ao9dtl79">
        <Reveal data-id="element-5" data-mp="3dhl0z7nu471m">
          <div data-id="element-6" data-mp="3dj5vixa5fpzh">
            <SectionHeading eyebrow={t('about.eyebrow')} title={t('about.title')} data-id="element-7" data-mp="3djfcxwh4ootk" />
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-navy-900/70" data-id="element-8" data-mp="3hkr1rzs6h60p">
              {t('about.body')}
            </p>

            <div className="mt-7 max-w-2xl border-l-2 border-amber-600 pl-5" data-id="element-9" data-mp="3rgaxal2ty2ox">
              <h3 className="font-display text-base font-extrabold text-navy-900" data-id="element-10" data-mp="2lr7hc36dy01d">
                {t('about.areasTitle')}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-navy-900/70" data-id="element-11" data-mp="2gr2yi6i08t7z">
                {t('about.areasBody')}
              </p>
              <ul className="mt-3 flex flex-wrap gap-x-2 gap-y-1.5" data-id="element-12" data-mp="2csn3pgfomgk0">
                {serviceAreas.map(area => <li key={area.id} data-id="element-13" data-mp="34hp7bzzu2hj1">
                    <a href={area.href} className="inline-flex rounded-full bg-navy-50 px-3 py-1 text-xs font-bold text-navy-900 transition-colors duration-150 ease-smooth hover:bg-amber-600 hover:text-white" data-id="element-14" data-mp="34hypx2ijtmep">
                      {area.name}
                    </a>
                  </li>)}
              </ul>
            </div>

            <ul className="mt-7 flex flex-col gap-3" data-id="element-15" data-mp="3o6r5h8sih8zm">
              {points.map(key => <li key={key} className="flex items-start gap-3" data-id="element-16" data-mp="3jdy2oqglsaq6">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-600 text-white" data-id="element-17" data-mp="663s8i77n9sh">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-18" data-mp="b3viz8w4cpv3" />
                  </span>
                  <span className="text-[15px] font-semibold text-navy-900" data-id="element-19" data-mp="3ti4nviy3ewhy">{t(key)}</span>
                </li>)}
            </ul>
            <a href={BUSINESS.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-md bg-navy-900 px-6 py-3.5 font-display text-sm font-bold text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-brand-600 active:scale-[0.98]" data-id="element-20" data-mp="3jkqajs7guntv">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="3eldnb6coneqr" />
              {BUSINESS.phoneDisplay}
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-22" data-mp="18t71i7vowsbb">
          <figure className="overflow-hidden rounded-2xl border border-navy-900/10 shadow-card" data-id="element-23" data-mp="1cuad2i6pg26q">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/41f71773-755b-44c2-a6e7-27ed04b4d633.jpg" alt="Completed exterior remodel with new siding and trim by JV Home Service" loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-24" data-mp="2xcb4ahnlhb03" />
            <figcaption className="bg-navy-900 px-6 py-5" data-id="element-25" data-mp="32aw8st9vqguc">
              <span className="block font-display text-sm font-bold text-white" data-id="element-26" data-mp="329be93nkexwh">
                {BUSINESS.owner} — {BUSINESS.name}
              </span>
              <span className="mt-1 block text-sm text-white/70" data-id="element-27" data-mp="3c05yy3l5xpft">{BUSINESS.area}</span>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>;
}